import {
  RingtoneType,
  startCallRingtone,
  stopCallRingtone,
} from '@src/logic/call/callRingtone';
import {
  selectHasOngoingCall,
  selectHasWaitingAgentCall,
  selectHasWaitingCall,
} from '@src/selectors/calls';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const useCallRingtone = () => {
  // TODO:
  // - implement startCallRingtone when needed (Note: take in account how to handle incoming/outgoing calls ringtone)

  const hasOngoingCall = useSelector(selectHasOngoingCall);
  const hasWaitingCalls = useSelector(selectHasWaitingCall);
  const hasWaitingAgentCall = useSelector(selectHasWaitingAgentCall);

  useEffect(() => {
    if (!hasWaitingCalls || hasOngoingCall) {
      stopCallRingtone();
    } else {
      startCallRingtone(
        hasWaitingAgentCall ? RingtoneType.INCOMING : RingtoneType.OUTGOING
      );
    }

    return () => stopCallRingtone();
  }, [hasWaitingCalls, hasWaitingAgentCall, hasOngoingCall]);
};

export default useCallRingtone;
